import { EditorPlugin } from '../core/PluginManager';
import { MarkdownProcessorPlugin } from '../../extensions/markdownSupport';
import { ChangeCollector } from '../../../utils/ChangeCollector';

/**
 * 基本Markdown处理插件实现
 */
export class MarkdownProcessorPluginImpl implements EditorPlugin, MarkdownProcessorPlugin {
  id = 'markdown-processor';
  
  // 创建 ChangeCollector 实例用于 Markdown 转换
  private changeCollector = new ChangeCollector();
  
  /**
   * 初始化插件
   */
  initialize(): void {
    console.log('Markdown处理插件初始化');
  }
  
  /**
   * HTML转Markdown
   */
  htmlToMarkdown(html: string): string {
    console.log('HTML转Markdown:', html.substring(0, 50) + '...');
    return html.replace(/<[^>]*>?/gm, '');
  }
  
  /**
   * Markdown转HTML
   */
  markdownToHtml(markdown: string): string {
    console.log('Markdown转HTML:', markdown.substring(0, 50) + '...');
    // 使用 ChangeCollector 中基于 remark 的实现
    return this.changeCollector.markdownToHtml(markdown);
  }
  
  /**
   * 兼容IncrementalMarkdownProcessor的接口
   */
  contentToHtml(markdown: string): string {
    return this.markdownToHtml(markdown);
  }
  
  /**
   * 兼容IncrementalMarkdownProcessor的接口
   */
  reset(): void {
    // 无状态处理器，不需要重置
    this.changeCollector.clearCache();
  }
  
  /**
   * 兼容IncrementalMarkdownProcessor的接口
   */
  getResult(): string {
    return '';
  }
  
  /**
   * 销毁插件
   */
  destroy(): void {
    console.log('Markdown处理插件销毁');
  }
} 